<template>
  <div>
    <v-img
      @click="handleRedirectToStore"
      src="https://novocare.b-cdn.net/wegovy/wegovy-mobile-banner.jpg"
      max-width="100%"
      style="cursor: pointer"
    />

    <div class="text-center mt-4">
      <ButtonElement
        text="Stáhnout aplikaci"
        color="primary"
        @click="handleRedirectToStore"
      />
    </div>

    <v-dialog v-model="showQrDialog" width="480">
      <v-card class="pa-6">
        <div class="text-h6 mb-2 text-center primary--text">
          Stáhnout aplikaci NovoCare
        </div>
        <div class="text-center mb-4 grey--text">
          Naskenujte QR kód pro stažení aplikace
        </div>
        <v-row justify="center">
          <v-col cols="6" class="text-center">
            <v-img
              src="../assets/img/qr-google-play.png"
              max-width="150"
              class="mx-auto"
            />
            <div class="mt-2">Google Play</div>
          </v-col>
          <v-col cols="6" class="text-center">
            <v-img
              src="../assets/img/qr-app-store.png"
              max-width="150"
              class="mx-auto"
            />
            <div class="mt-2">App Store</div>
          </v-col>
        </v-row>
        <div class="text-center mt-10">
          <v-btn outlined color="primary" @click="showQrDialog = false">
            Zavřít
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ButtonElement from "./elements/ButtonElement.vue";

export default {
  components: { ButtonElement },
  data() {
    return {
      showQrDialog: false,
    };
  },
  methods: {
    handleRedirectToStore() {
      const androidUrl =
        "https://play.google.com/store/apps/details?id=cz.tmesolutions.novocareapp&hl=cs&pli=1";
      const iosUrl =
        "https://apps.apple.com/cz/app/novocare-cz/id6499024041?l=cs";

      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      if (/android/i.test(userAgent)) {
        window.open(androidUrl, "_blank");
      } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.open(iosUrl, "_blank");
      } else {
        this.showQrDialog = true;
      }
    },
  },
};
</script>
